import ErrorMessage from 'utils/ErrorMessage'
import instRequest from 'utils/instRequest'
import { reportUrlMapping } from '../Reports/Partials/CommonData/reportData'
import studentRequest from '../../utils/studentRequest'

export const getDomainList =
  (campusId, category, search = '') =>
  async (dispatch, getState) => {
    try {
      let jobCategory = category ? `&jobCategory=${category}` : ''
      const response = await instRequest.get(
        `/instituteReportFilter/instituteCampusId/${campusId}/domain?${jobCategory}&search=${search}`
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDegreeList =
  (domainIds, campusId, category, search = '') =>
  async (dispatch, getState) => {
    try {
      let jobCategory = category ? `&jobCategory=${category}` : ''

      const response = await instRequest.get(
        `/instituteReportFilter/instituteCampusId/${campusId}/degree?domainId=${domainIds}${jobCategory}&search=${search}`
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDepartmentList =
  (campusId, payload, category) => async (dispatch, getState) => {
    try {
      const response = await instRequest.post(
        `/instituteReportFilter/instituteCampusId/${campusId}/streams`,
        payload
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getSpecializationList =
  (campusId, payload, category) => async (dispatch, getState) => {
    try {
      const response = await instRequest.post(
        `/instituteReportFilter/instituteCampusId/${campusId}/specialisations`,
        payload
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const exportCSV =
  (instituteCampusId, payload, type, selectedReport, isMetrics) =>
  async (dispatch, getState) => {
    let config
    if (isMetrics == false) {
      config = type !== 'googlesheet' ? { responseType: 'blob' } : {}
    }
    const reportKey = reportUrlMapping[selectedReport]

    // Add isMetrics to payload dynamically
    const updatedPayload = {
      ...payload,
      isMetrics, // Set dynamically based on function call
    }
    if(!updatedPayload?.jobCategory){
      updatedPayload.jobCategory = 'PLACEMENT'
    }

    try {
      let result 
      if(reportKey=='custom'){
        const customPayload ={
          ...updatedPayload,
          downloadList:payload?.downloadList || [],
        }
        result = await studentRequest.put(
          `/students/instituteCampus/${instituteCampusId}/customReport/${type}/export`,
          customPayload,
          config
        )
      }else{
        result = await instRequest.post(
          `instituteReport/instituteCampusId/${instituteCampusId}/export/${reportKey}`,
          updatedPayload,
          config
        )
      }
    
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

  export const customerReportDataList =
    () => async () => {
    try {
      const result = await studentRequest.get(
        `/students/institutes/heading/export?forReport=true`
      )
      const data = result?.data?.data || []
      return data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }